module.exports = __webpack_public_path__ + "static/desktopPreview-cf585b1361622c719cee6510881771ca.png";